import { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import { Button } from "reactstrap";
import apiService from "services/api";
import { CustomTable, ImageModal, ProtectedImg } from "components";
import { leaveTableColumns, otTableColumns } from "../constants";
import { FiSearch } from "react-icons/fi";
import { capitalize } from "utils/capitalize";
import { getFileExtension } from "utils/getFileExtension";
import StaffApplicationModal from "./StaffApplicationModal";

const AllApplicationsTemplate = ({ type = "leave" }) => {
	const isLeave = type === "leave";
	const { data, isLoading, refetch } = useQuery(type, () =>
		isLeave ? apiService.leave.get(undefined, { all_dates: true }) : apiService.ot.get(undefined, { all_dates: true })
	);

	const [displayLeaveModal, setDisplayLeaveModal] = useState(false);
	const [leaveToDisplay, setApplicationToDisplay] = useState({
		firstName: "",
		lastName: "",
		id: "",
		type: undefined,
		approvedReason: undefined,
	});

	const [imgExpanded, expandImage] = useState(false);

	const showDeleteModal = (leaveToDisplay) => {
		setApplicationToDisplay(leaveToDisplay);
		setDisplayLeaveModal(true);
	};

	// Hide the modal
	const hideConfirmationModal = () => {
		setDisplayLeaveModal(false);
	};

	const actions = useCallback(
		(row) => (
			<div className="actions-right">
				<Button color="warning" size="sm" className="btn-icon btn-link edit" onClick={() => showDeleteModal(row)}>
					<FiSearch size={20} />
				</Button>
			</div>
		),
		[]
	);

	return (
		<div className="content">
			<div className="d-flex mb-2">
				<Link to={`/${type.toLowerCase()}/new`}>
					<button type="button" className="btn btn-info">
						Add new {type}
					</button>
				</Link>
			</div>

			<StaffApplicationModal
				{...{
					leaveToDisplay,
					displayLeaveModal,
					hideConfirmationModal,
					type,
					expandImage,
					refetch,
				}}
			/>

			{getFileExtension(leaveToDisplay.proof) !== "pdf" && (
				<ImageModal open={imgExpanded} hideModal={() => expandImage(false)}>
					<ProtectedImg src={leaveToDisplay.proof} alt="" className="img-fluid" token={apiService.auth.token.get()} />
				</ImageModal>
			)}

			<CustomTable
				data={data}
				columns={type === "leave" ? leaveTableColumns : otTableColumns}
				defaultPageSize={25}
				title={capitalize(type) + "s"}
				actions={actions}
				loading={isLoading}
			/>
		</div>
	);
};

export default AllApplicationsTemplate;
